import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import useRefreshToken from "../hooks/useRefreshToken";

const RequireAuth = () => {
    const { auth, persist } = useAuth();
    const refresh = useRefreshToken();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                // Silently restore the session using the httpOnly refresh cookie
                await refresh();
            } catch (err) {
                console.error(err);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        // Only attempt silent refresh if persist is enabled and no token in memory
        if (!auth?.accessToken && persist) {
            verifyRefreshToken();
        } else {
            setIsLoading(false);
        }

        return () => { isMounted = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return null; // or a spinner
    }

    return (
        auth?.accessToken
            ? <Outlet />
            : <Navigate to="/adminlogin" state={{ from: location }} replace />
    );
}

export default RequireAuth;
